export default __webpack_public_path__ + "static/media/Florida_Seal.b8c038d1.png";